import React from 'react';
import { RightSidebar } from "../../../_partials/Layout";
import Sortable from "../../../../componets/Sortable";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { reorderYoutubeVideos } from "../../../../actions/mine_craft/youtubeVideosActions";
import usePermissions from "../../../../hooks/usePermissions";

const _SidebarIndex = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.youtubeVideos.ids);
  const categories = useAppSelector(state => state.mineCraft.youtubeVideos.entities);
  const { write_minecraft } = usePermissions();

  function onClickSave(ids: any[]) {
    dispatch(reorderYoutubeVideos({ ids }));
  }

  if (!write_minecraft) {
    return null;
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>

      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Reorder Youtube Videos</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={categories}
            titleKey='title'
            imageKey='preview_url'
          />
      }
    </RightSidebar>
  )
}

export default _SidebarIndex;
